module.exports = {
  GuideMultiInput: {
    PluginName: "Multi-Entrada de Formación",
    EmptyHint:
      "Área de Multi-Entrada de Formación — añade elementos desde la barra de herramientas",
    Items: "Elementos",
    ItemCount: "Número de Elementos",
    placeholder: "Escribe aquí…",
    add_tag: "Añadir etiqueta",
    kind_tag: "Etiqueta",
    tag_ref: "Referencia de etiqueta",
    tag_ref_placeholder: "ej. nombre",
    behavior_title: "Comportamiento",
    auto_advance: "Avanzar la escena al completar todos los pasos",
    cue_beacon: "Resaltado pulsante en el paso activo",
    cue_cursor: "El cursor guía se mueve al paso activo",
    cue_backdrop: "Atenuar la pantalla alrededor del paso activo",
    zoom_enabled: "Acercar al paso activo",
  },
};
